import { TFormField, FormFieldType } from '@models/forms';
import * as styles from '@components/modals/Modal.styles';
import { carriers } from '@components/modals/CancelationModal/CancelationModal.constants';
import { DollarSign } from '@assets/svgs';
import { getNumbers } from '@utils/regex';

export function getFormFields({
  declinationReasons,
  typeFieldItems,
  hasInternalOnlyAccessRestriction,
}: {
  typeFieldItems: string[];
  declinationReasons: string[];
  hasInternalOnlyAccessRestriction?: boolean;
}): {
  [fieldName: string]: TFormField;
} {
  return {
    reason: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'reason',
      label: 'Reason for Declination',
      fieldType: FormFieldType.SelectField,
      required: true,
      fieldConfig: {
        selectField: {
          options: declinationReasons.map((item) => ({
            value: item,
            label: item,
          })),
        },
      },
    },
    type: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'type',
      label: 'Type',
      fieldType: FormFieldType.SelectField,
      required: true,
      watchedField: 'reason',
      isVisible: ({ data }: { data: any }) => {
        return !!data.watchedField && ['Capacity', 'Loss History'].includes(data.watchedField);
      },

      fieldConfig: {
        selectField: {
          options: typeFieldItems.map((item) => ({
            value: item,
            label: item,
          })),
        },
      },
    },
    notes: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'notes',
      label: 'Declination Reason',
      fieldType: FormFieldType.TextField,
      required: true,
      helperText: 'This is internal only and will not be included in emails',
      watchedField: 'reason',
      isVisible: ({ data }: { data: any }) => {
        return !!data.watchedField;
      },
    },
    carrier: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'carrier',
      label: 'Carrier',
      fieldType: FormFieldType.SelectField,
      required: true,
      watchedField: 'reason',
      isVisible: ({ data }: { data: any }) => {
        return !!data.watchedField && data.watchedField !== 'Underwriting Issues';
      },
      fieldConfig: {
        selectField: {
          menuProps: { PaperProps: { sx: styles.selectMenuPaper } },
          options: carriers.map((item) => ({
            value: item,
            label: item,
          })),
        },
      },
    },
    otherCarrier: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'otherCarrier',
      label: 'Carrier Name',
      fieldType: FormFieldType.TextField,
      watchedField: 'carrier',
      isVisible: ({ data }: { data: any }) => {
        return data.watchedField === 'Other';
      },
    },
    premium: {
      gridWidth: { xs: 12, sm: 6, md: 6 },
      name: 'premium',
      label: 'Premium',
      fieldType: FormFieldType.TextField,
      required: true,
      watchedField: 'reason',
      isVisible: ({ data }: { data: any }) => {
        return !!data.watchedField && !['Underwriting Issues', 'Other'].includes(data.watchedField);
      },
      fieldConfig: {
        textField: {
          handleOnPattern: (value) => {
            return getNumbers(value);
          },
          startIcon: <DollarSign />,
        },
      },
    },
    messageToBroker: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      isVisible: () => {
        return !hasInternalOnlyAccessRestriction;
      },
      name: 'messageToBroker',
      label: 'Message to Broker (Optional)',
      fieldType: FormFieldType.TextField,
      watchedField: 'reason',
      helperText: 'Adding an optional message will send a second email to the broker',
    },
    confirmation: {
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'confirmation',
      label: `I'm sure that I want to decline this quote`,
      required: true,
      fieldType: FormFieldType.CheckboxField,
      sx: { marginBottom: '0px' },
    },
    shouldSkipEmail: {
      isVisible: () => {
        return !hasInternalOnlyAccessRestriction;
      },
      gridWidth: { xs: 12, sm: 12, md: 12 },
      name: 'shouldSkipEmail',
      label: `Send declination email to broker?`,
      required: true,
      fieldType: FormFieldType.RadioGroupField,
      sx: { marginBottom: '20px' },
      fieldConfig: {
        radioField: {
          // layout: 'vertical',
          options: [
            {
              value: 'false',
              label: 'Yes',
            },
            {
              value: 'true',
              label: 'No',
            },
          ],
        },
      },
    },
  };
}
